const ResultDetailRow = ({ label, value, valueClass = "", icon }) => {
  return (
    <div className="flex items-center justify-between p-4 rounded-lg theme-card hover:bg-secondary transition-colors">
      <div className="flex items-center space-x-3 space-x-reverse">
        {icon && <span className="text-secondary">{icon}</span>}
        <h2 className="text-lg font-semibold">{label}</h2>
      </div>
      <p className={`text-base ${valueClass}`}>{value}</p>
    </div>
  );
};

export default ResultDetailRow;

